export const CustomPrefix = 'custom:';

export const PPAttributes = {
  Email: 'email',
  EmailVerified: 'email_verified',
  FamilyName: 'family_name',
  GivenName: 'given_name',
  Name: 'name',
  PhoneNumber: 'phone_number',
  PhoneNumberVerified: 'phone_number_verified',
  UpdatedAt: 'updated_at',
  Website: 'website',
  Sub: 'sub',
  PPContactIdentifier: `${CustomPrefix}PPContactIdentifier`,
  Championships: `${CustomPrefix}Championships`,
};

export type PPCognitoUser = {
  [K in (typeof PPAttributes)[keyof typeof PPAttributes]]: string;
};
